import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {SharedService} from '../../../services/shared-service';
import {DateUtil} from '../../../util/DateUtil';
import {Common} from '../../../util/Util';
import {TableControl} from '../../../models/TableControl';
import {PaymentDTO} from '../../../../clm/models/payment/PaymentDTO';
import {PaymentsService} from '../../../../clm/services/payments.service';
import {
  UpdatePaymentReferenceDialogComponent
} from '../../../../clm/components/dialogs/update-payment-reference-dialog/update-payment-reference-dialog.component';
import {detailsExpand} from '../../../animations';
import {DisplayIcon} from '../../../components';

enum TableColumns {
  PaymentId = 'paymentId',
  PreAuthorisationPayment = 'preAuthorisationPayment',
  PaymentReference = 'paymentReference',
  PaymentExecutionDate = 'paymentExecutionDate',
  PaymentCompletionDate = 'paymentCompletionDate',
  Amount = 'amount',
}

@Component({
  selector: 'app-payment-overview',
  templateUrl: './payment-overview.component.html',
  styleUrls: [
    '../../../../../../styles/global/_management-styles.scss',
    '../../../../../../styles/global/_dialog-styles.scss'
  ],
  animations: [detailsExpand]
})
export class PaymentOverviewComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject();
  readonly dateFormat = DateUtil.dateFormat;
  readonly dateTimeFormat = DateUtil.dateTimeFormat;
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly TableColumns = TableColumns;
  readonly DisplayIcon = DisplayIcon;

  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  paymentTableControl: TableControl;
  paymentExpandedRow: PaymentDTO | null;
  paymentDisplayedColumns: string[] = Object.values(TableColumns);
  paymentDataSource: MatTableDataSource<PaymentDTO> = new MatTableDataSource();

  constructor(
    public dialog: MatDialog,
    private paymentsService: PaymentsService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetailDTO: BasicPersonDetailDTO
  ) {
    this.paymentTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'paymentId',
      'desc',
      'paymentId',
      ''
    );
  }

  @ViewChild('MatSortPaymentOverview') set matSort(ms: MatSort) {
    if (!ms) {
      return;
    }
    this.paymentDataSource.sortingDataAccessor = (item: PaymentDTO, property: string) => {
      switch (property) {
      case TableColumns.PreAuthorisationPayment:
        return item.casePayments.length;
      case property:
        return item[property];
      default:
        return null;
      }
    };
    this.paymentDataSource.sort = ms;
  }

  @ViewChild('MatPaginatorPaymentOverview') set matPaginatorIssueStep(mp: MatPaginator) {
    if (!mp) {
      return;
    }
    this.paymentDataSource.paginator = mp;
  }

  get isDataExist(): boolean {
    return !!(this.paymentDataSource && this.paymentDataSource?.data.length);
  }

  ngOnInit(): void {
    if (this.basicPersonDetailDTO.personId) {
      this.getListOfPaymentsByInsuredPersonID(this.basicPersonDetailDTO.personId);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  openPaymentDialog(event: MouseEvent, paymentDTO: PaymentDTO): void {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef: MatDialogRef<UpdatePaymentReferenceDialogComponent> = this.dialog.open(UpdatePaymentReferenceDialogComponent, {
      width: '40vw',
      data: paymentDTO
    });
  }

  isPreAuthorisationPayment(payment: PaymentDTO): boolean {
    return payment.casePayments != null && payment.casePayments.length > 0;
  }

  private getListOfPaymentsByInsuredPersonID(personId: number): void {
    this.paymentsService.getListOfPaymentsByInsuredPersonId(personId)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (payments: PaymentDTO[]) => {
          this.paymentDataSource.data = payments;
          this.paymentTableControl.length = payments.length;
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openSnackBar(error.businessMessage || 'There was an error getting the payments', 'Dismiss');
        }
      });
  }
}

